import { jsx as _jsx } from "theme-ui/jsx-runtime";
import { BreadCrumbItem } from "./BreadCrumbItem";
import { Flex } from "theme-ui";
import { ArrowRight } from "../../Icons/ArrowRight";
export const BreadCrumbDivider = () => (_jsx(BreadCrumbItem, { children: _jsx(Flex, { sx: { px: 12, height: 16, svg: { height: 16, width: 16 } }, children: _jsx(ArrowRight, {}) }) }));
//# sourceMappingURL=BreadCrumbDivider.js.map